import React from "react";
import { Link } from "react-router-dom";
import {
  LocationMarkerIcon,
  CalendarIcon,
  UserGroupIcon,
} from "@heroicons/react/solid"; // Tailwind Heroicons

const guests = [
  { value: "1 person", label: "1 person" },
  { value: "2 person", label: "2 person" },
  { value: "3+ person", label: "3+ persons" },
];
const SearchBar = () => {
  return (
    <div>
      <form
        className="mx-auto mt-8 rounded-2xl bg-white p-6 shadow-lg md:p-8"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-5 lg:gap-6">
          {/* Location - always first row */}
          <div className="flex w-full flex-col items-start">
            <label className="mb-1 font-semibold text-gray-700">Location</label>
            <div className="relative w-full">
              <LocationMarkerIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
              <input
                type="text"
                placeholder="New York, USA"
                className="w-full rounded-full border border-gray-300 py-2 pl-10 pr-3 focus:outline-none focus:ring-2 focus:ring-indigo-600"
              />
            </div>
          </div>

          {/* Check-in & Check-out - side by side on small, separate on large */}
          <div className="flex w-full flex-row gap-6 lg:col-span-2">
            <div className="flex w-1/2 flex-col items-start lg:w-full">
              <label className="mb-1 font-semibold text-gray-700">
                Check-in
              </label>
              <div className="relative w-full">
                <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                <input
                  type="date"
                  className="w-full rounded-full border border-gray-300 py-2 pl-10 pr-3 text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                />
              </div>
            </div>
            <div className="flex w-1/2 flex-col items-start lg:w-full">
              <label className="mb-1 font-semibold text-gray-700">
                Check-out
              </label>
              <div className="relative w-full">
                <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                <input
                  type="date"
                  className="w-full cursor-pointer rounded-full border border-gray-300 py-2 pl-10 pr-3 text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                />
              </div>
            </div>
          </div>

          {/* Guest - always below on small screens, in correct grid position on large */}
          <div className="flex w-full flex-col items-start lg:col-span-1">
            <label className="mb-1 font-semibold text-gray-700">Guest</label>
            <div className="relative w-full rounded-full border border-gray-300">
              <UserGroupIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
              <select
                defaultValue="2 person"
                className="w-full appearance-none rounded-full py-2 pl-10 pr-3 text-[#000] focus:outline-none"
              >
                {guests.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Search Button - in same row on large screens */}
          <div className="hidden lg:flex lg:flex-col lg:items-start lg:justify-end">
            <Link
              to="/hotels"
              className="block min-w-[150px] rounded-full bg-indigo-900 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700"
            >
              Search Hotels
            </Link>
          </div>
        </div>

        {/* Search Button - separate row for small screens */}
        <div className="mt-6 flex w-full flex-col items-center gap-3 lg:hidden">
          <Link
            to="/hotels"
            className="block w-full min-w-[150px] rounded-full bg-indigo-900 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700 md:w-auto"
          >
            Search Hotels
          </Link>
          <Link
            to="/hotellist"
            className="block w-full min-w-[150px] rounded-full bg-indigo-900 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700 md:hidden md:w-auto"
          >
            Apply Filter
          </Link>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
